import React from 'react'
import clsx from 'clsx'

import { Spinner } from 'ui/Spinner/Spinner'

type Props = {
  sizeClassName?: `w-${string} h-${string}`
  text?: string
  className?: string
}

export const Loading = React.memo((props: Props) => {
  const { sizeClassName = 'w-4 h-4 -mt-1', text = 'Loading...', className } = props
  return (
    <div className={clsx('flex', className, 'w-fit')}>
      <div role="status">
        <Spinner sizeClassName={`${sizeClassName} mr-1`} />
        <span className="sr-only">Loading...</span>
      </div>
      {text}
    </div>
  )
})

export const FullScreenLoading = React.memo((props: Props) => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <Loading {...props} />
    </div>
  )
})
